import { SET_USER, UNSET_USER } from 'constant';

export const setUser = (user) => ({ type: SET_USER, payload: user });

export const unsetUser = () => ({ type: UNSET_USER });
